// styles.js
export const overlayStyle = (isOpen: boolean): React.CSSProperties => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9999,
  display: isOpen ? 'block' : 'none',
  transition: 'opacity 0.3s ease-in-out',
  opacity: isOpen ? 1 : 0,
  transform: isOpen ? 'none' : 'translateX(-100%)',
});

export const drawerStyle = (isOpen: boolean): React.CSSProperties => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: 'calc(100vw - 30px)',
  maxWidth: '480px',
  height: '100dvh',
  backgroundColor: '#fff',
  zIndex: 10000,
  transition: 'all 0.3s ease-in-out',
  overflowY: 'auto',
  transform: isOpen ? 'none' : 'translateX(-100%)',
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
});
